import { Link } from '@com-delta-idp/mnx-ui-kit';

export interface AEMLevelStatusAriaLabel {
  millionMiler: string;
  level: string;
}

export interface TrackerStatus {
  action: Link;
  lifeTimeLabel: string;
  minMillerStatusLimit: string;
  maxMillerStatusLimit: string;
  millerStatusLabel: string;
  ariaLabel: AEMLevelStatusAriaLabel;
}

export interface LegendsList {
  title: string;
}

export interface Legends {
  legendsList: LegendsList[];
}

export interface TrackerAriaLabel {
  statusLabel: string;
  currentValueLabel: string;
  minValueLabel: string;
  maxValueLabel: string;
  accureMoreLabel: string;
  svgIconLabel: string;
  andIconLabel: string;
  orIconLabel: string;
  flightIconLabel: string;
  spendIconLabel: string;
  completeIconLabel: string;
}

export interface TrackerDetails {
  action: Link;
  completeLabel: string;
  completeOneLabel: string;
  detailsCards: string;
  dollars: string;
  flightQualifierLabel: string;
  info: string;
  tooltipInfo: string;
  legends: Legends;
  trademark: string;
  miles: string;
  pendingInfoLabel: string;
  earnedStatusLabel: string;
  delta360Label: string;
  pendingLabel: string;
  rolloverMQMLabelEndOfYear: string;
  rolloverMQMLabelBeginningOfyear: string;
  segments: string;
  spendQualifierLabel: string;
  statusProgressLabel: string;
  toLabel: string;
  knowMoreLabel: string;
  knowMoreUrl: string;
  cardImageUrl: string;
  cardImageLabel: string;
  ariaLabel: TrackerAriaLabel;
  waiverCardLabel: string;
  waiverCardToolTip: string;
  waiverInfoLabel: string;
  waiverLabelTitle: string;
}

export interface AEMTracker {
  trackerDetails: TrackerDetails;
  trackerStatus: TrackerStatus;
}
